var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EEF0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_20040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8976 37.2381C40.0404 36.474 39.29 35.598 38.6665 34.6337C37.9851 33.3029 37.5771 31.8491 37.4665 30.3581V25.967C37.4724 23.6253 36.623 21.3621 35.0778 19.6025C33.5327 17.843 31.3982 16.7082 29.0754 16.4115V15.2648C29.0754 14.9501 28.9504 14.6482 28.7278 14.4257C28.5053 14.2031 28.2034 14.0781 27.8887 14.0781C27.574 14.0781 27.2722 14.2031 27.0496 14.4257C26.8271 14.6482 26.702 14.9501 26.702 15.2648V16.4292C24.4001 16.7474 22.2914 17.889 20.7665 19.6427C19.2417 21.3963 18.404 23.6431 18.4087 25.967V30.3581C18.2981 31.8491 17.8901 33.3029 17.2087 34.6337C16.5962 35.5958 15.8578 36.4717 15.0132 37.2381C14.9183 37.3214 14.8424 37.424 14.7902 37.5389C14.7381 37.6539 14.7111 37.7786 14.7109 37.9048V39.1137C14.7109 39.3494 14.8046 39.5755 14.9713 39.7422C15.138 39.9089 15.3641 40.0026 15.5998 40.0026H40.3109C40.5467 40.0026 40.7728 39.9089 40.9395 39.7422C41.1062 39.5755 41.1998 39.3494 41.1998 39.1137V37.9048C41.1997 37.7786 41.1726 37.6539 41.1205 37.5389C41.0684 37.424 40.9924 37.3214 40.8976 37.2381ZM16.5598 38.2248C17.3867 37.4257 18.1148 36.5304 18.7287 35.5581C19.5872 33.951 20.0875 32.177 20.1954 30.3581V25.967C20.1601 24.9253 20.3349 23.8871 20.7092 22.9143C21.0835 21.9415 21.6498 21.0539 22.3743 20.3045C23.0987 19.5551 23.9666 18.9592 24.9262 18.5521C25.8858 18.1451 26.9175 17.9354 27.9598 17.9354C29.0022 17.9354 30.0339 18.1451 30.9934 18.5521C31.953 18.9592 32.8209 19.5551 33.5454 20.3045C34.2699 21.0539 34.8361 21.9415 35.2105 22.9143C35.5848 23.8871 35.7595 24.9253 35.7243 25.967V30.3581C35.8321 32.177 36.3325 33.951 37.1909 35.5581C37.8048 36.5304 38.533 37.4257 39.3598 38.2248H16.5598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 42.972C28.5603 42.9591 29.0977 42.7486 29.5174 42.3777C29.9371 42.0068 30.2121 41.4994 30.2937 40.9453H25.6182C25.7021 41.5145 25.99 42.0338 26.4282 42.4066C26.8664 42.7794 27.4251 42.9803 28.0004 42.972Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_20040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.69f3ec216f9f59fbc0d0d2d7e8c30d43.svg";
export { ForwardRef as ReactComponent };